import { useQuery } from 'react-query';

import patientPolicies from 'api/patientPolicies/patientPolicies';
import QUERY_KEYS from 'constants/queryKeys/queryKeys';

export const usePatientPolicyQuery = (patientId: number, isPro?: boolean) =>
  useQuery([QUERY_KEYS.PATIENT_POLICIES, patientId], patientPolicies.getPoliciesForPatient(patientId, isPro), { enabled: !!patientId });
